import { render } from "./DemandForecastingRowManual.vue?vue&type=template&id=3460a472&scoped=true"
import script from "./DemandForecastingRowManual.vue?vue&type=script&lang=js"
export * from "./DemandForecastingRowManual.vue?vue&type=script&lang=js"

import "./DemandForecastingRowManual.vue?vue&type=style&index=0&id=3460a472&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3460a472"]])

export default __exports__